<template>
<transition name="modal-fade">
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-body">
                <slot name="body">
                    <img src="//res.uuudian.com/hk_data/522e760f-086b-4101-96d6-b01ea92e2843" alt="">
                    <p>兑换成功</p>
                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <p>查看订单</p>
                    <p>继续兑换</p>
                </slot>
            </div>
        </div>
    </div>
</transition>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style scoped lang="less">
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal {
    background-color: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 78.2666vw;
    border-radius: 1vw;
}

.modal-body {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 6.9333vw 0;
    font-size: 4.266666vw;
    color: #3c3c3c;
    
    img {
        width: 16.2666vw;
        height: 16.2666vw;
        margin-bottom: 2.66666vw;
    }
    p {
        width: 100%;
        text-align: center;
        margin: 0;
    }
    
}

.modal-footer {
    display: flex;
    flex: 2;
    p {
        flex: 1;
        margin: 0;
        text-align: center;
        font-size: 4vw;
        padding: 5.0666vw;
    }
    p:last-child {
        background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
        color: #fff;
    }
    border-top: 1px solid #eee;
    justify-content: flex-end;
}

.btn-close {
    border: none 0;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background-color: transparent;
}

.btn-green {
    color: #fff;
    background-color: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease
}
</style>




// WEBPACK FOOTER //
// src/components/common/Modal/success.vue